export default __webpack_public_path__ + "static/media/hero card.08e12a1e.jpg";